<template>
  <div class="container">
    <div class="page-title">公告列表</div>
    <div class="content">
      <div class="content-top" v-if="role == 1">
        <el-button @click="add(null)" style="width: 100px;margin-left: 30px;" size="small" type="primary">新增</el-button>
      </div>
      <div class="content-bottom">
        <el-table
          :data="tableData"
          stripe
          style="width:100%;flex:1;overflow:auto;"
          v-loading="listLoading"
          >
          <el-table-column
            prop="date"
            label="序号"
            width="100">
            <template slot-scope="scope">
              {{scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            width="300">
          </el-table-column>
          <el-table-column
            label="时间"
            width="170">
            <template slot-scope="scope">
              {{scope.row.startTime | rTime}}
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="结束时间"-->
<!--            width="170">-->
<!--            <template slot-scope="scope">-->
<!--              {{scope.row.endTime | rTime}}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            label="发布状态"
            v-if="role == 1"
            width="170">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">删除</span>
              <span v-else-if="scope.row.status === 1">草稿</span>
              <span v-else-if="scope.row.status === 2">发布</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="200">
            <template slot-scope="scope" >
              <div style="display: flex;align-items: center;" v-if="role == 1">
                <el-button @click="updateNotice(scope.row.noticeId,0)" type="danger" size="small">删除</el-button>
                <el-button @click="add(scope.row.noticeId)" type="primary" size="small">更新</el-button>
                <el-button @click="updateNotice(scope.row.noticeId,2)" type="primary" size="small">发布</el-button>
              </div>
              <div v-else>
                <div style="display: flex;align-items: center;">
                  <el-button @click="add(scope.row.noticeId)" type="primary" size="small">查看</el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="[5, 10, 20, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value2: '',
        orderNumber: '',
        tableData: [],
        options: [{
          value: '选项1',
          label: '已通过'
        }, {
          value: '选项2',
          label: '未通过'
        }, {
          value: '选项3',
          label: '未审核'
        }],
        value: '',
        total: 0,
        pageSize: 10,
        currentPage:1,
        listLoading: false,
        accessConfig: {},
        role: 1
      };
    },
    activated () {
      this.role = window.sessionStorage.role;
      this.queryData(this.currentPage,this.pageSize);
    },
    methods: {
      queryData(currentPage,pageSize){
        this.$http.post(`/plan/findNoticeByPage/${currentPage}/${pageSize}`, {  }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            console.log('res====',res)
            console.log('resdata====',res.data)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.tableData = res.data.data.list;
              this.total = res.data.data.total;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      updateNotice(noticeId, status){
        this.$http.post(`/plan/updateNotice`, {
          noticeId, status
        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              const message = status === 0 ? '删除成功' : '发布成功';
              this.$message.success(message);
              this.currentPage = 1;
              this.queryData(this.currentPage,this.pageSize);
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      handleSizeChange: function (size) {
        this.pageSize = size;
        console.log(this.pageSize);  //每页下拉显示数据
        this.queryData(this.currentPage,this.pageSize);
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        console.log(this.currentPage);  //点击第几页
        this.queryData(this.currentPage,this.pageSize);
      },
      handleClick2(row,status) {
        console.log('row========',row);
        const url = status === 2 ? `/user/userRefuse/${row.id}` : `/user/userpass/${row.id}`
        this.$http.post(url, {
          id: row.id
        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.$message.success(res.data.data)
              this.queryData(this.currentPage,this.pageSize);
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      add(noticeId){
        if(noticeId){
          this.$router.push({ name: "NoticeEdit",query:{noticeId} });
        }else{
          this.$router.push({ name: "NoticeEdit"});
        }
      }
    },
    filters: {
      rTime(data) {
        if(!data) return
        var dt = new Date(data);
        var y = dt.getFullYear();
        var m = (dt.getMonth()+1).toString().padStart(2,"0");
        var d = dt.getDate().toString().padStart(2,"0");
        var h = dt.getHours().toString().padStart(2,"0");
        var mm = dt.getMinutes().toString().padStart(2,"0");
        var s = dt.getSeconds().toString().padStart(2,"0");
        return `${y}-${m}-${d} ${h}:${mm}:${s}`;
      },
    }
  };
</script>
<style lang="less" scoped>
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .content {
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex: 1;
    margin-top: 10px;
    .content-top {
      display: flex;
      align-items: center;
      /*margin-top: 10px;*/
      margin-bottom: 10px;
      /*position: fixed;*/
      /*justify-content: flex-start;*/
      /*flex-direction: column;*/
      .first-line {
        display: flex;
        justify-content: flex-start;
      }
      .label {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        /*text-align: right;*/

        color: #000000;
        padding-right: 10px;
      }
      .date-box {
        display: flex;
        align-content: center;
        padding-left: 12px;
      }
    }
    .content-bottom {
      flex: 1;
      /*position: fixed;*/
      /*top: 185px;*/
      /*bottom: 0;*/
      /*left: 147px;*/
      /*right: 0;*/
      overflow: auto;
      /*margin-bottom: 10px;*/
      display: flex;
      flex-direction: column;
    }
    .content-bottom /deep/ .el-table__body {
      /*width: 100%!important;*/
    }
  }
</style>
